import { render } from "./LogoButton.vue?vue&type=template&id=0584309a"
import script from "./LogoButton.vue?vue&type=script&lang=js"
export * from "./LogoButton.vue?vue&type=script&lang=js"

import "./LogoButton.vue?vue&type=style&index=0&id=0584309a&lang=css"

import exportComponent from "C:\\Users\\griff\\source\\repos\\Owen Associates\\Owen Associates\\Owen_Interiors\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__